<template>
	<div class="unishop-modal-cart" @click="showCarritoModal()">
		<!-- <div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">{{ modalTitle }}</p>
				<button class="delete" aria-label="close" @click="closeModal(false)"></button>
			</header>
			<section class="modal-card-body">
				<div v-if="!isCheckoutSection">
					<div class="box" v-for="product in products" :key="product.id">
						<button class="is-pulled-right button is-info is-inverted" @click="removeFromCart(product.id)">{{ removeLabel }}</button>
						<p>{{ product.title }}  {{ product.quantity > 0 ?  ` - Quantity: ${product.quantity}` : ''}}</p>
						<p>{{ product.price }} &euro;</p>
					</div>
					<div v-if="products.length === 0">
						<p>{{ cartEmptyLabel }}</p>
					</div>
				</div>
				<div v-if="isCheckoutSection">
					<p>You bought it :-)</p>
				</div>
			</section>
			<footer class="modal-card-foot">
				<button v-show="products.length > 0 && !isCheckoutSection" class="button is-success" @click="onNextBtn">{{ buyLabel }}</button>
				<button v-if="isCheckoutSection" class="button is-success" @click="closeModal(true)">{{ closeLabel }}</button>
			</footer>
		</div> -->
		<div id="unishop-cart-wrap" class="unishop-cart-wrap px-0 pt-0" @click.stop="">
			<a class="unishop-modal-close carrito my-2" @click="$store.commit('showCarritoModal', false)"></a>
			<div class="unishop-empty-message" v-if="products.length<1">El carrito esta vacío</div>
				<v-divider></v-divider>
				<ul class="unishop-cart-orders " v-if="products.length>0">
					
					<li class="pt-3 px-3 mb-0 pb-0" v-for="product in products" :key="product.id + '/' + product.codigo">
						<div class="mb-1">
							<p class=" mb-0 d-flex">
							<v-btn  absolute right icon class="primary" @click="removeFromCart(product.id, product.codigo)" title="Eliminar">
								<v-icon>delete</v-icon>
							</v-btn>
								<span class="no-flex text-uppercase font-weight-bold mr-2">{{ product.modelo }} </span>
							</p>
							<span class="no-flex">{{ product.codigo }}</span><span claas="no-flex font-weight-medium body-1 ml-2"> {{ product.color }}</span>
						</div>
						
						<div class="mb-2 d-flex pb-2">
							<div class="image no-flex mr-2" :style="{ backgroundImage: 'url(' + product.foto  + ')' }">
							</div>
							<div class="d-flex flex-column  ml-auto">
									<Nota @actualizar="actualizar" :idProducto="product.id" :codProducto="product.codigo" :key="product.id + '--' + product.codigo"></Nota>
									<p class="ml-auto no-flex mb-0 mt-2">
										<span class="no-flex mr-1">
											{{ product.cantidad }} und
										</span>x<span class="no-flex mx-1">{{ formatMoney(product.precio) }}</span>=
										<span class="ml-auto no-flex ml-1 subheading">{{ formatMoney(product.precio *  product.cantidad) }}</span>
									</p>
									<p class="font-weight-light no-flex align-center  caption d-flex ml-auto mb-0" v-if="product.nota !== '' && product.nota !==null && product.nota !==undefined">
										<!--<span>Coste extra unitario</span>-->
										<v-icon class="grey--text subheading">edit_note</v-icon>
										<span class="mx-1 ">Nota {{ product.cantidad }} </span>x
										<span class="no-flex mx-1">{{ formatMoney(Number(product.coste || 0))}}</span>=
										<span class="no-flex ml-1 subheading">{{ formatMoney((Number(product.coste || 0)) * product.cantidad)}}</span>
									</p>
								<p class="d-flex mb-2 align-end mt-1">
								<span class="no-flex ml-auto">Total</span>
								<span class="no-flex ml-2 title">
									{{ formatMoney((product.precio + Number((product.coste || 0))) * product.cantidad)}}
								</span>
								</p>
							</div>
						</div>
						<!--<<div >
								<div class="unishop-order-options d-flex align-right">
									<span>Talla {{ product.talla }}</span>
									<span class="body-1">
										{{ formatMoney(product.precio) }}
									</span>
								</div>
								<div class="d-flex">
									<div class="flex-grow-0">{{ product.cantidad }}<span class="ml-1">Und.</span></div>
									<p class="title mb-0">{{ formatMoney((product.precio + Number((product.coste || 0))) * product.cantidad) }}</p>
								</div>
							div class="unishop-order-subtotal">
								<span>{{ product.precio * product.cantidad }}&euro;

								</span>
							</div>
						</div>
						<div >
							<Nota @actualizar="$forceUpdate()" :idProducto="product.id" :codProducto="product.codigo" :key="product.id + '--' + product.codigo"></Nota>
						</div>-->
						<v-divider class=""></v-divider>
					</li>
				</ul>
				<v-divider></v-divider>
				<div class="unishop-cart-total">
					<span>Unidades:&nbsp;{{ totalUds }}</span>
					<span>Subtotal:&nbsp;{{ subtotal }}</span>
					<span class="title mt-2"><strong>TOTAL:&nbsp; {{ total }} </strong></span>
				</div>
				<div  class="px-4">
					<v-text-field v-model="idCliente" placeholder="Cliente" @change="cambiarCliente"/>
				</div>
				<div class="tipo-ticket px-4" v-show="!isSys4Conjunto()">
					<v-select
						:items="tiposTicket"
						item-value="id"
						item-text="nombre"
						label="Tipo"
						v-model="vTipo"
						attach
						@change="cambiarTipo" />
				</div>
				<div v-if="showFechaReserva">
						<v-checkbox
							v-model="reiniciarFecha"
							label="Reinicar fecha reserva"
						></v-checkbox>
				</div>
				<div class="unishop-cart-buttons ">
					<v-btn @click="limpiar()">Borrar todo</v-btn>
					<v-btn color="primary" @click="aparcarTicket()">Aparcar<!-- <img style="margin-left:4px;" src='@/assets/images/Btn_aparcarTCK.png'>--></v-btn>
				</div>	
		</div>
		<!-- Componente para añadir notas -->
		
	</div>
</template>
<script>
import { TicketApiService } from '@/api/TicketApiService'
import { Util } from '@/api/Util'
const ticketApiService = new TicketApiService()
const util = new Util()

import Nota from './Nota';


export default {
	name: 'checkout',
	components: { Nota },
	data () {
		return {
			idCliente: "",
			tiposTicket: [{nombre:'Tienda', id : 0},{nombre:'Reserva', id : 1}],
			vTipo:0,
			reiniciarFecha: false,
			showFechaReserva: false,
			idProducto: null,
			codProducto: '',
			refreshKey: 0,
		}
	},

	computed: {
		products () {
			return this.$store.getters.getProductsCart;
		},
		subtotal () {
			let subtotal = 0;
			this.refreshKey;
			this.$store.getters.getProductsCart.forEach(element => {
				subtotal += (Number(element.precio) + Number((element.coste || 0))) * element.cantidad
			},subtotal);
			return this.formatMoney(subtotal);
		},
		total () {
			let total = 0;
			this.refreshKey;
			this.$store.getters.getProductsCart.forEach(element => {
				total += (Number(element.precio) + Number((element.coste || 0))) * element.cantidad
			},total);
			return this.formatMoney(total);
		},
		totalUds () {
			let totalUds = 0;
			this.refreshKey;
			this.$store.getters.getProductsCart.forEach(element => {
				totalUds += element.cantidad
			},totalUds);
			return totalUds;
		},
		cliente () {
			return this.$store.getters.getCliente
		}
		// 	openModal () {
		// 		if (this.$store.getters.isCheckoutModalOpen) {
		// 			return true;
		// 		} else {
		// 			return false;
		// 		}
		// 	},
		// 	buyLabel () {
		// 		let totalProducts = this.products.length,
		// 				productsAdded = this.$store.getters.productsAdded,
		// 				pricesArray = [],
		// 				productLabel = '',
		// 				finalPrice = '',
		// 				quantity = 1;

		// 		productsAdded.forEach(product => {

		// 			if (product.quantity >= 1) {
		// 				quantity = product.quantity;
		// 			}

		// 			pricesArray.push((product.price * quantity)); // get the price of every product added and multiply quantity
		// 		});

		// 		finalPrice = pricesArray.reduce((a, b) => a + b, 0); // sum the prices
				
		// 		if (totalProducts > 1) { // set plural or singular
		// 			productLabel = 'products';
		// 		} else {
		// 			productLabel = 'product';
		// 		}
		// 		return `Buy ${totalProducts} ${productLabel} at ${finalPrice}€`;
		// },
		// isUserLoggedIn () {
		// 	return this.$store.getters.isUserLoggedIn;
		// }
	},
	watch: {
		products (value) {
			if (value.length<1) {
				this.$store.commit('showCarritoModal', false)
			}
		},
		cliente(value) {
			if (value !== null) {
					this.idCliente = value.email
			} else {
				this.idCliente = null
			}
		}
	},
	created() {
		if (localStorage.getItem("tipoTicket") === null) {
			this.vTipo = 0
		} else {
			this.vTipo = parseInt(localStorage.getItem('tipoTicket'))
		}
		if (localStorage.getItem("idClienteTicket") === null) {
			if (this.cliente !== null) {
				this.idCliente = this.cliente.email
			} else {
				this.idCliente = ''
			}
		} else {
			this.idCliente = localStorage.getItem('idClienteTicket')
		}
		if (localStorage.getItem("fechaTicket") === null) {
			this.showFechaReserva = false
		} else {
			this.showFechaReserva = true
		}
	},
	methods: {
		openNota() {
			this.dialog = true
		},
		actualizar () {
			//hack para forzar el recalculo de los totales
			this.refreshKey++
		},
		cambiarTipo () {
			localStorage.setItem('tipoTicket', this.vTipo)
		},
		cambiarCliente () {
			localStorage.setItem("idClienteTicket", '')
		},
		showCarritoModal () {
			if (this.$store.getters.isCarritoModalOpen) {
				this.$store.commit('showCarritoModal', false);
			} else {
				this.$store.commit('showCarritoModal', true);
			}
    },
		// closeModal (reloadPage) {
		// 	this.$store.commit('showCheckoutModal', false);

		// 	if (reloadPage) {
		// 		window.location.reload();
		// 	}
		// },
		removeFromCart (id, codigo) {
			let data = {
					id: id,
					codigo: codigo
			}
			this.$store.commit('removeFromCart', data);
			
			// this.$store.commit('setAddedBtn', data);
		},
		aparcarTicket() {
			if (this.$store.getters.getProductsCart.length !== 0) {
				var ticketAux={
					cabecera: {
						msct_opuid : this.$store.getters.getOpuid,
						msct_tipo : this.vTipo,
						msct_puesto: "000",
						msct_id_cliente : this.idCliente
					}
				}
				if (localStorage.getItem("fechaTicket") !== null && this.vTipo === 1) {
					if (!this.reiniciarFecha) {
						Object.defineProperty(ticketAux.cabecera,'msct_fecha',{value: localStorage.getItem("fechaTicket")})
					}
				}
				let lineasTicketAux= {
					lineasticket : []
				}
				this.$store.getters.getProductsCart.forEach(element => {
					let lineaTicketAux= {
						mslt_codigo_escaneo : element.codigo,
						mslt_precio : element.precio,
						mslt_descuento: 0,
						mslt_unidades: element.cantidad,
						mslt_nota: element.nota,
						mslt_coste_extra: element.coste,
						mslt_tipo_nota: 0 // TODO: de momento va a castaña faltan por definir los tipos de nota...
					}
					lineasTicketAux.lineasticket.push(lineaTicketAux)
				},lineasTicketAux);
				Object.assign(ticketAux, lineasTicketAux)
				ticketApiService.addTicket(ticketAux)
					.then(data => {
						this.$store.state.productsCart=[]
						localStorage.removeItem('tipoTicket')
						localStorage.removeItem('idClienteTicket')
						localStorage.removeItem('fechaTicket')
						util.mostrarEnConsola('ticketApiService - addTicket', data.length, 'OK')
						this.showCarritoModal()
					})
					.catch(error => {
						this.$root.$emit('mostrarAlerta', this.$t('lang.comun.error'), 'error')
						util.mostrarEnConsola('ticketApiService - addTicket', error, 'ERROR')
						this.showCarritoModal()

					})
			}
		},
		limpiar() {
			this.showFechaReserva = false
			localStorage.removeItem('tipoTicket')
			localStorage.removeItem('idClienteTicket')
			localStorage.removeItem('fechaTicket')
			this.$store.state.productsCart=[]
		},
		formatMoney (num) {
      return util.formatMoney(num)
    },
		// onNextBtn () {
		// 	if (this.isUserLoggedIn) {
		// 		this.isCheckoutSection = true;
		// 	} else {
		// 		this.$store.commit('showCheckoutModal', false);
		// 		this.$store.commit('showLoginModal', true);
		// 	}
		// },
		// onPrevBtn () {
		// 	this.isCheckoutSection = false;
		// }
	}
}
</script>

